$(document).ready( function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // AJAX FILTERS
    function filter( page ) {
        let form = $('form.js-load-products-filter :not(.js-not)'),
            url  = form.attr('action'),
            data = form.serialize();

        $('.loading').show();

        if ( page ) {
            data += "&page="+page;
        } else {
            $('.js-load-products').hide();
        }

        window.location.hash = data;

        $.ajax({
            url: url,
            data: data,
            processData: false,
            method: 'POST',
            type: 'POST'
        }).done(function(content) {

            let loadProducts = $('.js-load-products');
            prepareDataToGTM(content, 'view_item_list');

            loadProducts.show();
            loadProducts.html( content.products );
            $('.js-load-pagination').html( content.pagination );

            $('.loading').hide();

            if ( $(window).width() < 767 && isCategoryPage() )
                scrollToProductsOnMobile();

        }).fail(function(content) {
            console.log(content);
        });

    }

    function startFilter() {
        let form = $('form.js-load-products-filter'),
            url  = form.attr('action'),
            data = window.location.hash.substring(1);

        form.deserialize(data);

        $('.loading').show();

        $.ajax({
            url: url,
            data: data,
            processData: false,
            method: 'POST',
            type: 'POST'
        }).done(function(content) {

            $('.loading').hide();
            $('.js-load-products').html( content.products );
            $('.js-load-pagination').html( content.pagination );

            // if ( $(window).width() < 767 && isCategoryPage() )
            //     scrollToProductsOnMobile();

        }).fail(function(content) {
            console.log(content);
        });

    }

    $(document).on('click', '.js-next-page', function (e) {
        e.preventDefault();
        filter($(this).attr('data-page'));
    });

    $(document).on('change', '.js-load-products-change', function (e) {
        filter();
    });

    if ( window.location.hash && window.location.href.indexOf('kategorie') > -1 ) {
        startFilter();
    }
    else if ( $('.js-load-products').length ) {
        filter();
    }

    function isCategoryPage() {
        return window.location.href.indexOf('kategorie') > -1 && window.location.href.indexOf('obchod') === -1;
    }

    function scrollToProductsOnMobile() {
        $('html,body').stop().animate({
            scrollTop: $('.js-load-products-filter').offset().top
        })
    }

    function prepareDataToGTM(data, eventName) {
        const items = data.productsData.map((product, index) => {
            return {
                'item_id': product.external_id,
                'item_name': product.name,
                'affiliation': 'Eshop',
                'coupon': '',
                'discount': '',
                'index': index + 1,
                //'item_brand': product.brand ? product.brand.name : '',
                'item_category': data.categoryName,
                'item_list_id': '',
                'item_list_name': '',
                'item_variant': '',
                'location_id': '',
                'price': product.prices_by_shop[0].price,
                'quantity': 1
            };
        });
        const dataLayer = {
            'event': eventName,
            'ecommerce': {
                item_list_id: data.categoryId,
                item_list_name: data.categoryName,
                items: items
            }
        };
        window.dataLayer.push(dataLayer);
    }

});
